import OutgoingCheck from '@/models/OutgoingCheck/OutgoingCheck';

export default class OutgoingCheckFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.outgoingCheckNumber = '';
		this.id = '';
		this.deliveryInstructionId  = '';
		this.deliveryInstructionDiNumber = '';
		this.processById  = '';
		this.processByFirstName = '';
		this.processDateFrom = '';
		this.processDateTo = '';
		this.outgoingCheckStatusId  = '';
		this.outgoingCheckStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			outgoingCheckNumber : '0',
			id : '0',
			deliveryInstructionId : '0',
			deliveryInstructionDiNumber : '0',
			processById : '0',
			processByFirstName : '0',
			processDateFrom : '0',
			processDateTo : '0',
			outgoingCheckStatusId : '0',
			outgoingCheckStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}